import { Trans } from "@lingui/macro"

import * as Century from "@/domains/centuries"
import { nthCentury } from "@/lib/messages"
import { CSS } from "@/stitches"
import * as Select from "@/ui/select"

export function CenturiesSelect({
  value,
  onValueChange,
  disabled = false,
  css,
}: {
  value: Century.Century | undefined
  onValueChange: (value: Century.Century) => void
  disabled?: boolean
  css?: CSS
}) {
  return (
    <Select.Root
      value={value === undefined ? "" : String(value)}
      onValueChange={(value) => {
        const numberValue = parseInt(value)
        if (Number.isInteger(numberValue)) {
          onValueChange(numberValue as Century.Century)
        }
      }}
    >
      <Select.Trigger
        disabled={disabled}
        css={css}
        isPlaceholder={value === undefined}
      />
      <Select.Content>
        <Select.Item placeholderItem disabled value="">
          <Trans id="auctionList.filters.century.placeholder">
            Vyberte století
          </Trans>
        </Select.Item>
        {Century.pastCenturies.map((century) => (
          <Select.Item key={century} value={String(century)}>
            {nthCentury(century as Century.Century)}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  )
}
